/* globals Vue, VueSlideUpDown, MediaQuery, _ */
/* exports vm */
/* esnext */

'use strict';

(function(){

    var vm = new Vue({

        el: '#press-app',

        data: {

            appVersion: 9,

            config: window.$App.config,
            texts: window.$App.texts,

            selection: {},

            selectionMaxAge: 1000*60*60*24, // 1 day

            formData: {
                firstname: '',
                lastname: '',
                publication: '',
                country: '',
                telephone: '',
                email: '',
            },

            formErrors: [],

            isSelectionDetailVisible: false,
            isDownloadFormVisible: false,

            isLoading: false,
            isDownloadFormSubmitted: false,
            downloadURL: null,
            downloadTitle: null,

            checkboxClassname: 'js-download-checkbox',
        },

        filters: {

        },

        beforeMount () {
            this.restoreSelection();
        },

        mounted () {
            document.addEventListener('change', this.handleSelectionCheckboxChange);
            document.addEventListener('keyup', this.handleEscapeKey);
        },

        beforeDestroy () {
            document.removeEventListener('change', this.handleSelectionCheckboxChange);
            document.removeEventListener('keyup', this.handleEscapeKey);
        },

        computed: {

            __ () {
                return this.texts;
            },

            localstorageKey () {
                return `selection-v${this.appVersion}`;
            },

            localstorageUpdateKey () {
                return `${this.localstorageKey}-updated`;
            },

            selectionCount () {
                return Object.keys(this.selection).length;
            },

            hasSelection () {
                return this.selectionCount > 0;
            },

            selectionFileArray () {
                return Object.values(this.selection).map(item => item.file);
            },

            isOpen: {
                get () {
                    return this.isSelectionDetailVisible || this.isDownloadFormVisible;
                },
                set (newValue) {
                    this.isSelectionDetailVisible = newValue;
                    this.isDownloadFormVisible = newValue;
                },
            },

            classNames () {
                return [
                    {
                        'has-selection': this.hasSelection,
                        'is-selection-detail-visible': this.isSelectionDetailVisible,
                        'is-download-form-visible': this.isDownloadFormVisible,
                        'is-download-form-submitted': this.isDownloadFormSubmitted,
                        'is-open': this.isOpen,
                    }
                ];
            },

            hasEmptyFormFields () {
                return !this.formData.email;
            },

            isDownloadFormValid () {
                return !this.hasEmptyFormFields;
            },

            isDownloadButtonClickable () {
                return this.hasSelection || (this.isDownloadFormVisible && this.isDownloadFormValid);
            },
        },

        methods: {

            resetView () {
                this.isSelectionDetailVisible = true;
                this.isDownloadFormVisible = false;
                this.isDownloadFormSubmitted = false;
            },

            toggleDrawer () {
                if (this.isOpen) {
                    this.isOpen = false;
                }
                else if (this.hasSelection) {
                    this.isSelectionDetailVisible = true;
                }
            },

            handleSubmit (event) {
                if (this.isDownloadFormVisible) {
                    //if (this.isDownloadFormValid) {
                        this.handleDownload(event);
                    //}
                }
                else if (this.hasSelection) {
                    this.isDownloadFormVisible = true;
                }
            },

            handleDownload (event) {
                event.preventDefault();
                var submissionURL = $(event.target).attr('action');

                this.isLoading = true;
                this.isDownloadFormSubmitted = true;
                this.downloadURL = null;
                this.downloadTitle = null;

                this.$http.post(
                    submissionURL,
                    {
                        download:  true,
                        selection: this.selectionFileArray,
                        request:   this.formData,
                    },
                    {
                        emulateJSON: true,
                        responseType: 'json',
                    })
                .then(response => {
                    this.isLoading = false;
                    if (response.ok && response.body) {

                        var errors = response.body.errors,
                            downloadURL = response.body.url,
                            downloadTitle = response.body.name;

                        this.formErrors = errors;

                        if (downloadURL && !this.formErrors.length) {
                            this.downloadURL = downloadURL;
                            this.downloadTitle = downloadTitle;
                            setTimeout(() => window.location = downloadURL, 4000);
                        }
                    }
                    else {
                        this.handleHttpError(response);
                    }
                }, this.handleHttpError);
            },

            handleHttpError (response) {
                console.error('Error fetching data', response);
            },

            hasSelectionItem (key) {
                return !!this.selection[key];
            },

            removeSelectionItem (key) {
                this.$delete(this.selection, key);
                this.setSelectionCheckboxState(key, false);
            },

            addSelectionItem (key, file, caption, srcset) {
                this.$set(this.selection, key, {
                    key: key,
                    file: file,
                    caption: caption,
                    srcset: srcset,
                });
                this.setSelectionCheckboxState(key, true);

                return this.selection[key];
            },

            setSelectionCheckboxState (key, state) {
                var checkboxes = document.querySelectorAll('#' + key);
                checkboxes.forEach(checkbox => checkbox.checked = state);
            },

            setAllSelectionCheckboxStates () {
                Object.values(this.selection).forEach(item => {
                    this.setSelectionCheckboxState(item.key, true);
                });
            },

            restoreSelection () {
                var userSelection = localStorage.getItem(this.localstorageKey),
                    lastUpdate = localStorage.getItem(this.localstorageUpdateKey);

                if (userSelection) {

                    if (lastUpdate && this.selectionMaxAge > 0) {
                        var now  = Date.now(),
                            age = now - lastUpdate;

                        if (age > this.selectionMaxAge) {
                            // localStorage.clear();
                            localStorage.removeItem(this.localstorageKey);
                            userSelection = null;
                        }
                    }

                    var selectionObj = JSON.parse(userSelection);
                    if (selectionObj !== null && typeof selectionObj === 'object') {
                        this.selection = selectionObj;
                        this.setAllSelectionCheckboxStates();
                    }
                }
            },

            storeSelection () {
                var selection = JSON.stringify(this.selection),
                    now = Date.now();

                localStorage.setItem(this.localstorageKey, selection);
                localStorage.setItem(this.localstorageUpdateKey, now);
            },

            handleSelectionCheckboxChange (event) {
                if (event.target.classList.contains(this.checkboxClassname)) {

                    var $checkbox = $(event.target),
                        $file = $checkbox.closest('.js-file'),
                        $img = $file.find('img'),
                        isChecked = $checkbox.is(':checked'),
                        fileKey = $checkbox.attr('id'),
                        fileValue = $checkbox.val(),
                        fileCaption = $file.data('caption'),
                        imgSources = $img.data('srcset') || $img.data('src') || $img.attr('src');

                    if (isChecked) {
                        this.addSelectionItem(fileKey, fileValue, fileCaption, imgSources);
                    }
                    else {
                        this.removeSelectionItem(fileKey);
                    }
                }
            },

            handleEscapeKey (event) {
                if (event.keyCode === 27) { // esc

                }
            },

        },

        watch: {
            selection: {
                handler () {
                    this.storeSelection();
                },
                deep: true
            },

            isDownloadFormVisible (val) {
                if (val) {
                    this.isSelectionDetailVisible = false;
                }
            },

            isDownloadFormSubmitted (val) {
                if (!val) {
                    this.downloadURL = null;
                    this.downloadTitle = null;
                    this.formErrors = [];
                }
            },

            isOpen (val) {
                if (!val) {
                    this.isDownloadFormSubmitted = false;
                }
            },
        }
    });

})();
